import React, { useState } from 'react';
import './TuSeleccion.css';

const CANCHAS = [
  {
    nombre: 'Suprema Corte',
    key: 'suprema_corte',
    img: '/assets/img/BoletaYT_SCJN.webp',
    mujeres: 5,
    hombres: 4,
  },
  {
    nombre: 'Tribunal de Disciplina',
    key: 'tribunal_disciplina',
    img: '/assets/img/BoletaYT_TDJ.webp',
    mujeres: 3,
    hombres: 2,
  },
  {
    nombre: 'Tribunal Electoral',
    key: 'tribunal_electoral',
    img: '/assets/img/BoletaYT_SSTE.webp',
    mujeres: 1,
    hombres: 1,
  },
];

function TuSeleccion({ seleccion, onEditarCancha }) {
  const [mostrarMenuCompartir, setMostrarMenuCompartir] = useState(false);

  const handleCompartirWhatsApp = () => {
    const url = encodeURIComponent('www.canchaelectoral.com');
    const mensaje = encodeURIComponent('¡Mira mi selección en Cancha Electoral!');
    window.open(`https://wa.me/?text=${mensaje}%20${url}`, '_blank');
  };

  const handleCompartirFacebook = () => {
    const url = encodeURIComponent('www.canchaelectoral.com');
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
  };

  return (
    <div className="tu-seleccion">
      <h1 className="titulo-seleccion">Tu selección</h1>
      <div className="canchas-seleccion">
        {CANCHAS.map((cancha) => {
          const seleccionados = seleccion[cancha.key] || [];
          const mujeres = seleccionados.filter(c => c.SEXO === 'MUJER').map(c => c.NUM_LISTA_EN_BOLETA);
          const hombres = seleccionados.filter(c => c.SEXO === 'HOMBRE').map(c => c.NUM_LISTA_EN_BOLETA);
          
          return (
            <div className="cancha-boton-wrapper" key={cancha.key}>
              <div className="cancha-nombre">{cancha.nombre}</div>
              <button className="cancha-boton" onClick={() => onEditarCancha(cancha.key)}>
                <div className="cancha-img-wrapper">
                  <img src={cancha.img} alt={cancha.nombre} className="cancha-img" />
                  <div className={`numeros-container ${
                    cancha.key === 'tribunal_electoral' ? 'numeros-tribunal-electoral' :
                    cancha.key === 'tribunal_disciplina' ? 'numeros-tribunal-disciplina' : ''
                  }`}>
                    {/* Números de mujeres */}
                    {Array.from({ length: cancha.mujeres }).map((_, index) => (
                      <div key={`mujer-${index}`} className="numero-item">
                        {mujeres[index] || ''}
                      </div>
                    ))}
                    
                    {/* Espacio entre mujeres y hombres */}
                    <div className="espacio-separador"></div>
                    
                    {/* Números de hombres */}
                    {Array.from({ length: cancha.hombres }).map((_, index) => (
                      <div key={`hombre-${index}`} className="numero-item">
                        {hombres[index] || ''}
                      </div>
                    ))}
                  </div>
                </div>
              </button>
            </div>
          );
        })}
      </div>
      <div className="acciones-seleccion" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className="contenedor-compartir">
          <button 
            className="btn-compartir boton-imagen-seleccion"
            onClick={() => setMostrarMenuCompartir(!mostrarMenuCompartir)}
            style={{
              background: 'transparent',
              border: 'none',
              boxShadow: 'none',
              padding: 0,
              margin: 0,
              display: 'inline-block',
              position: 'relative',
              width: 160,
              height: 56,
            }}
          >
            <span style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 700,
              fontSize: '0.8em',
              textShadow: '0 2px 8px #222, 0 0 8px #000, 0 1px 0 #fff4',
              pointerEvents: 'none',
              zIndex: 2,
            }}>Compartir selección</span>
            <img src="/assets/img/seleccion.webp" alt="Compartir selección" style={{width: 160, height: 56, display: 'block', borderRadius: 0}} />
          </button>
          {mostrarMenuCompartir && (
            <div className="menu-compartir">
              <button onClick={handleCompartirWhatsApp} className="btn-red-social whatsapp">
                WhatsApp
              </button>
              <button onClick={handleCompartirFacebook} className="btn-red-social facebook">
                Facebook
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TuSeleccion; 